/** Profile navigates to /practice/new with this flag so the walkthrough runs after load. */
export const STORAGE_PENDING_NEW_MANUAL = 'akoreps_pendingManualNewPracticeTour';

/** Profile sends users to the list with this flag; cleared when a session opens. */
export const STORAGE_PENDING_SESSION_MANUAL = 'akoreps_pendingManualSessionTour';
